var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{staticClass:"rounded-1rem",attrs:{"size":"32px","color":_vm.imagen ? null : 'white'}},[(_vm.imagen)?_c('v-img',{attrs:{"src":_vm.imagen,"width":"100%"}}):_vm._e(),(!_vm.imagen)?_c('svg-icon',{attrs:{"color":"dark","width":"1.5rem","height":"1.5rem","name":"far-user-circle"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }